<template>
  <div class="container px-md-4">
    <div class="row">
      <div class="col-md-12 o-hero-slider pb-6 pb-md-10 overflow-hidden">
        <vue-glide
          v-if="content.heroSliderItems && content.heroSliderItems.length > 1"
          v-model="activeIndex"
          class="o-hero-slider__container"
          v-bind="glideOptions"
        >
          <vue-glide-slide
            v-for="(heroSliderItem, index) in content.heroSliderItems"
            :key="heroSliderItem.key"
            class="overflow-hidden"
          >
            <hero-video-item
              v-if="!$isNullOrUndefined(heroSliderItem.youtubeVideoID) || !$isNullOrUndefined(heroSliderItem.video)"
              :is-active="activeIndex === index"
              :hero-item="heroSliderItem"
              :alternate-layout="content.nzSettingAlternateLayout"
            />
            <hero-item
              v-else
              :is-active="activeIndex === index"
              :hero-item="heroSliderItem"
              :alternate-layout="content.nzSettingAlternateLayout"
            />
          </vue-glide-slide>
          <template slot="control">
            <div data-glide-dir="<">
              <base-arrow
                class="arrow -left"
                aria-label="previous"
              />
            </div>
            <div class="slider-numbers pb-2 pb-md-1"> 
              {{ activeIndex + 1 }} 
              / 
              {{ content.heroSliderItems.length }}
            </div>
            <div data-glide-dir=">">
              <base-arrow aria-label="next" />
            </div>
          </template>
        </vue-glide>
        <hero-video-item
          v-else-if="!$isNullOrUndefined(content.heroSliderItems) && content.heroSliderItems.length === 1 && isVideo"
          :hero-item="content.heroSliderItems[0]"
          :alternate-layout="content.nzSettingAlternateLayout"
          :is-active="true"
        />
        <hero-item
          v-else-if="!$isNullOrUndefined(content.heroSliderItems) && content.heroSliderItems.length === 1"
          :hero-item="content.heroSliderItems[0]"
          :alternate-layout="content.nzSettingAlternateLayout"
        />
      </div>
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
import HeroItem from '@/components/molecules/HeroItem';
import HeroVideoItem from '@/components/molecules/HeroVideoItem';
import BaseArrow from '@/components/atoms/BaseArrow';

export default {
  name: 'HeroSlider',
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    BaseArrow,
    HeroItem,
    HeroVideoItem
  },
  mixins: [contentMixin],
  data () {
    return {
      glideOptions: {
        type: 'carousel',
        gap: 0,
        perView: 1,
        bullet: false,
        autoplay: this.content.autoplaySlides ? 5000 : false,
      },
      activeIndex: 0
    };
  },
  computed: {
    isVideo () {
      return this.content.heroSliderItems[0]?.youtubeVideoID || this.content.heroSliderItems[0]?.video ? true : false;
    }
  }
};
</script>
